import { IconDefinition } from '@fortawesome/free-regular-svg-icons'
import React from 'react'
import { SecondaryButton } from '../../../components/Buttons/SecondaryButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type MenuButtonProps = {
  text: string
  icon: IconDefinition
  onClick?: (x: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  className?: string
}

export function MenuButton({
  text,
  icon,
  onClick,
  disabled,
  className,
}: MenuButtonProps) {
  const classes = ['h-18 flex-col space-y-2', className]
    .filter(Boolean)
    .join(' ')

  return (
    <SecondaryButton
      width={'full'}
      className={classes}
      onClick={onClick}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={icon} />
      <span className={'uppercase'}>{text}</span>
    </SecondaryButton>
  )
}